import { useMemo } from 'react';
// material
import componentsOverride from './overrides';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import typography from './typography';
import palette from "./palette";


export default function ThemeProvider({ children }) {
  const themeOptions = useMemo(
    () => ({
      typography,
      palette,
    }),
    []
  );

  const theme = createTheme(themeOptions);
    theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
